import { useSelector } from 'react-redux'
import type { AppointmentEventType } from '@pbt/pbt-ui-components'

import { appointmentStatus3POnly } from '~/constants/appointmentStatusRestrictions'
import FeatureToggle from '~/constants/featureToggle'
import { getCurrentBusinessIsOmniChannel } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'

export const useFilteredAppointmentStatuses = (
  appointmentStatuses: AppointmentEventType['states'],
) => {
  const isOmni = useSelector(getCurrentBusinessIsOmniChannel)
  const isFeatureEnabled = useSelector(
    getFeatureToggle(FeatureToggle.CVC_APPOINTMENT_STATUS_FILTER),
  )
  return isOmni && isFeatureEnabled
    ? appointmentStatuses.filter(
        (s) => !Object.values(appointmentStatus3POnly).includes(s.name),
      )
    : appointmentStatuses
}
